import { Routes } from '@angular/router'

export const routes: Routes = [
    {
        path: ':productType/:companySlug',
        loadChildren: () => import('./quote/quote.routes').then((m) => m.QUOTE_ROUTES),
        title: 'Boiler Quote',
    },
    {
        path: 'quote/acceptance/:token',
        loadComponent: () =>
            import('./quote-wizard/quote-acceptance/quote-acceptance.component').then(
                (m) => m.QuoteAcceptanceComponent
            ),
        title: 'Quote Acceptance',
    },
    {
        path: '',
        redirectTo: 'boiler/surefire',
        pathMatch: 'full',
    },
    {
        path: '**',
        loadComponent: () => import('./not-found/not-found.component').then((m) => m.NotFoundComponent),
    },
]
